import React from 'react'

/**
 * A simple excerpt component that only
 * returns a div with the excerpt if one is passed in.
 */
export default function Excerpt({ html }) {
  return html ? (
    <div
      className="headingexcerpt"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  ) : null
}
